const collator = Intl.Collator();

export { collator };
//# sourceMappingURL=collator.mjs.map
